import React from "react";

const MediumPersonIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="212"
    height="239"
    viewBox="0 0 212 239"
    fill="none"
  >
    <path
      d="M159 80C159 109.283 135.283 133 106 133C76.7175 133 53 109.283 53 80L54.4575 67.545L13.25 46.875L106 0.5L198.75 46.875V113.125H185.5V53.5L157.543 67.545L159 80ZM106 159.5C164.565 159.5 212 183.217 212 212.5V239H0V212.5C0 183.217 47.435 159.5 106 159.5Z"
      fill="black"
    />
  </svg>
);

export default MediumPersonIcon;
